import React from "react";
import { Grid } from "@mui/material";
import { Icon } from "@iconify/react";
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";

export default function UserColumn(props) {
    const navigate = useNavigate();
    const handleApprovalStatus = props.handleApprovalStatus
    const userColumn = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        // },
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            renderCell: (params) => {
                return (
                    <Grid onClick={() => navigate(`/userView/${params.row.id}?type=edit`)}>
                        <span style={{ color: "darkblue", cursor: 'pointer' }}>  {params.value}  </span>
                    </Grid>
                );
            },
        },
        {
            field: 'userType',
            headerName: 'User Type',
            flex: 1
        },
        {
            field: 'country',
            headerName: 'Country',
            flex: 1
        },
        {
            field: 'ecosystemIntegrator',
            headerName: 'Ecosystem',
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        <span>{params.value ?? "-"}</span>
                    </>
                );
            },
        },
        {
            field: 'initiative',
            headerName: 'Initiative Ecosystem',
            flex: 1
        },
        {
            field: 'subscription',
            headerName: 'Subscription Plan',
            flex: 1
        },
        {
            field: 'approvalStatus',
            headerName: 'Status',
            flex: 1,
            valueFormatter: (params) => {
                const labelMap = {
                    APPROVED: 'Approved',
                    REJECTED: 'Rejected',
                    PENDING: 'Pending',
                };
                return labelMap[params] || params;
            },
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 1,
            renderCell: (params) => {
                const isPending = params.row.approvalStatus === 'PENDING';

                return (
                    <Grid>
                        <IconButton aria-label="approve" size="small" onClick={() => isPending && handleApprovalStatus('APPROVED', [params.row.id])} disabled={!isPending} >
                            <Icon icon="material-symbols-light:check-box-outline-sharp" width="24" height="24" style={{ color: isPending ? '#285D54' : '#ccc' }} />
                        </IconButton>
                        <IconButton aria-label="reject" size="small" onClick={() => isPending && handleApprovalStatus('REJECTED', [params.row.id])} disabled={!isPending}>
                            <Icon icon="gg:close-r" width="18" height="18" style={{ color: isPending ? '#C40000' : '#ccc' }} />
                        </IconButton>
                    </Grid>
                );
            }
        }
    ];

    return userColumn;
}
